import PropTypes from 'prop-types';
import { forwardRef } from 'react';

import Anchor from '../Anchor';
import Image from '../Image';

const SidebarImage = forwardRef(
  ({ alt, imageProps, href, src, target, ...rest }, ref) => (
    <Anchor
      as="a"
      display="block"
      rel="noreferrer"
      width="100%"
      mb={4}
      ref={ref}
      href={href}
      target={target}
      {...rest}
    >
      <Image borderRadius="0.25rem" src={src} alt={alt} {...imageProps} />
    </Anchor>
  )
);

SidebarImage.displayName = 'SidebarImage';

SidebarImage.defaultProps = {
  imageProps: null,
  target: '_blank',
};

SidebarImage.propTypes = {
  alt: PropTypes.string.isRequired,
  imageProps: PropTypes.shape(),
  href: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
  target: PropTypes.string,
};

export default SidebarImage;
